import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import {
  PassedRulesStatistics,
  RulesCompliance,
  RulesStatistics,
} from '@internal/backstage-plugin-catalog-devops-common';
import { DefaultApiClient } from '@internal/backstage-plugin-devops-react';
import { RulesStatisticsApi } from './RulesStatisticsApi';

export class RulesStatisticsApiClient
  extends DefaultApiClient
  implements RulesStatisticsApi
{
  public constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    super({
      backendName: 'catalog',
      ...options,
    });
  }

  // The enveloped DefaultApiResponse must be checked before dereferencing:
  // on a failed request body is null and `body.items` would throw.
  private unwrapItems<T>(response: {
    succeeded: boolean;
    error: string | Error | null;
    body: any;
  }): T {
    if (!response.succeeded) {
      throw new Error(
        typeof response.error === 'string'
          ? response.error
          : response.error?.message ?? 'Rules statistics request failed',
      );
    }
    return response.body?.items ?? [];
  }

  async getRulesStatistics(accountId: string): Promise<RulesStatistics[]> {
    const urlSegment = `v2/statistics/rules?accountId=${encodeURIComponent(accountId)}`;
    return this.unwrapItems<RulesStatistics[]>(await this.get(urlSegment));
  }

  async getPassedRulesStatistics(
    accountId: string,
  ): Promise<PassedRulesStatistics[]> {
    const urlSegment = `v2/statistics/passed-rules?accountId=${encodeURIComponent(accountId)}`;
    return this.unwrapItems<PassedRulesStatistics[]>(
      await this.get(urlSegment),
    );
  }

  async getCompliance(
    accountId: string,
  ): Promise<Record<string, RulesCompliance>> {
    const urlSegment = `v2/statistics/compliance?accountId=${encodeURIComponent(accountId)}`;
    return this.unwrapItems<Record<string, RulesCompliance>>(
      await this.get(urlSegment),
    );
  }

  async getComplianceByRuleSet(
    ruleSetName: string,
  ): Promise<Record<string, RulesCompliance>> {
    const urlSegment = `v2/statistics/compliance-by-rule-set?ruleSetName=${encodeURIComponent(ruleSetName)}`;
    return this.unwrapItems<Record<string, RulesCompliance>>(
      await this.get(urlSegment),
    );
  }
}
